var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 23.8126L2.66675 22.4792V27.8126H6.66675V23.8126ZM29.3334 22.4792L25.3334 23.8126V27.8126H29.3334V22.4792Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 6.47925C6.66675 4.27011 8.45761 2.47925 10.6667 2.47925H21.3334C23.5426 2.47925 25.3334 4.27011 25.3334 6.47925V18.4792H6.66675V6.47925Z",
    fill: "url(#paint0_linear_887_4793)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 9.146H5.33337C3.12424 9.146 1.33337 10.9369 1.33337 13.146V19.8127C1.33337 22.0218 3.12423 23.8127 5.33337 23.8127H26.6667C28.8758 23.8127 30.6667 22.0218 30.6667 19.8127V13.146C30.6667 10.9369 28.8758 9.146 26.6667 9.146H25.3334V18.4793L25.2156 18.1261C24.4897 15.9483 22.4516 14.4793 20.156 14.4793H11.8441C9.54846 14.4793 7.51039 15.9483 6.78445 18.1261L6.66671 18.4793V9.146Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4793",
    x1: 25.3334,
    y1: 18.4792,
    x2: 3.93123,
    y2: 8.14388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.6cf181d7430b7a694b75a9ea2ef10a7b.svg";
export { ForwardRef as ReactComponent };